import useSeo from "@/hooks/useSeo";
import { gossipFaqs } from "@/mocks/faqs";
import { gossipEvents } from "@/mocks/events";
import { siteInfo } from "@/mocks/site";
import Hero from "@/pages/home/components/Hero";
import HotRadar from "@/pages/home/components/HotRadar";
import CategoryGrid from "@/pages/home/components/CategoryGrid";
import LatestDigest from "@/pages/home/components/LatestDigest";
import TrackFlow from "@/pages/home/components/TrackFlow";
import FaqSection from "@/pages/home/components/FaqSection";
import Testimonials from "@/pages/home/components/Testimonials";
import SubscribeForm from "@/components/feature/SubscribeForm";

export default function Home() {
  useSeo({
    title: "网报吃瓜 - 网报吃瓜事件库，热门瓜合集与盘点列表一站追完",
    description:
      "网报吃瓜把近期热点按事件串整理成合集、盘点与列表，打开就是网报吃瓜事件库。一个瓜从发生、发酵到后续逐条记录，按顺序追完，不用再到各平台零散拼时间线。",
    keywords:
      "网报吃瓜,网报吃瓜汇总,网报吃瓜合集,网报吃瓜盘点,网报吃瓜整理,网报吃瓜列表,网报吃瓜大全",
    canonical: "https://zhongjianshuyuan.cn/",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: siteInfo.name,
        url: "https://zhongjianshuyuan.cn/",
        description: siteInfo.description,
        inLanguage: "zh-CN",
        potentialAction: {
          "@type": "SearchAction",
          target: "https://zhongjianshuyuan.cn/events?q={search_term_string}",
          "query-input": "required name=search_term_string",
        },
      },
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: siteInfo.name,
        url: "https://zhongjianshuyuan.cn/",
        email: siteInfo.email,
        description: "以事件串方式整理网络热点与娱乐话题的内容站点。",
      },
      {
        "@context": "https://schema.org",
        "@type": "ItemList",
        name: "网报吃瓜热门事件串",
        itemListElement: [...gossipEvents]
          .sort((a, b) => b.heat - a.heat)
          .slice(0, 6)
          .map((event, index) => ({
            "@type": "ListItem",
            position: index + 1,
            name: event.title,
            url: `https://zhongjianshuyuan.cn/events/${event.id}`,
          })),
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: gossipFaqs.map((faq) => ({
          "@type": "Question",
          name: faq.question,
          acceptedAnswer: { "@type": "Answer", text: faq.answer },
        })),
      },
    ],
  });

  return (
    <>
      <Hero />
      <HotRadar />
      <CategoryGrid />
      <LatestDigest />
      <TrackFlow />
      <FaqSection />
      <Testimonials />
      <SubscribeForm />
    </>
  );
}